const STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  pending: { bg: "#3a3a1f", fg: "#d8c97c", label: "In queue" },
  in_progress: { bg: "#1f2f3a", fg: "#7fc4ec", label: "In progress" },
  processing: { bg: "#1f2f3a", fg: "#7fc4ec", label: "Running" },
  in_review: { bg: "#2a2a3a", fg: "#b3a8d8", label: "In review" },
  review_needed: { bg: "#3a2f1a", fg: "#C8A84B", label: "⚠ Needs review" },
  ready: { bg: "#1f3a26", fg: "#7cd99a", label: "Ready" },
  complete: { bg: "#1f3a26", fg: "#7cd99a", label: "Delivered" },
  failed: { bg: "#3a1f1f", fg: "#ec8b8b", label: "Failed" },
  refunded: { bg: "#2a2a2a", fg: "#a1a1a1", label: "Refunded" },
  cancelled: { bg: "#3a1f1f", fg: "#ec8b8b", label: "Cancelled" },
  pending_payment: { bg: "#2a2a2a", fg: "#a1a1a1", label: "Awaiting payment" },
};

export function StatusPill({ status }: { status: string }) {
  const s = STYLES[status] ?? { bg: "#2a2a2a", fg: "#a1a1a1", label: status.replace(/_/g, " ") };
  const ring = status === "review_needed" ? "ring-1 ring-[#C8A84B]/60" : "";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] ${ring}`}
      style={{ backgroundColor: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}